import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
}
export function Button({
  children,
  className = '',
  onClick,
  ...props
}: ButtonProps) {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (onClick) {
      onClick(e);
    } else {
      document.getElementById('cta-section')?.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <button className={`bg-terracotta hover:bg-terracotta-dark text-white font-bold py-4 px-8 rounded-full shadow-lg transition-all duration-300 transform hover:-translate-y-1 w-full sm:w-auto text-lg ${className}`} onClick={handleClick} {...props} data-id="element-12">
      {children}
    </button>;
}